<template>
    <div class="mt20">
        <div class="one-title">督导意见</div>
        <avue-form ref="form" v-model="orderForm" :option="orderOption" @submit="handleSubmit" @error="error">
            <template slot="menuForm" v-if="!isDetail">
                <el-button type="primary" size="mini" @click="goNextHandle(3)">上一步</el-button>
            </template>
        </avue-form>
        <div class="mt10 tac" v-if="isDetail">
            <el-button type="primary" size="mini" @click="goNextHandle(3)">上一步</el-button>
        </div>
    </div>
</template>
<script>
import { add, update } from "@/api/archives/index";
export default {
    props: {
        data: {
            type: Object,
            default: {}
        },
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            orderForm: {},
            orderOption: {
                size: 'mini',
                detail: this.isDetail,
                labelWidth: 100,
                emptyBtn: false,
                column: [{
                    labelWidth: 120,
                    label: '5.1个案需要跟进',
                    prop: 'isFollowUp',
                    type: 'checkbox',
                    dataType: "number",
                    dicUrl: "/api/blade-system/dict-biz/dictionary",
                    dicQuery: {
                        code: 'yes_no'
                    },
                    props: {
                        label: "dictValue",
                        value: "dictKey"
                    },
                    span: 24
                }, {
                    labelWidth: 68,
                    label: '5.2个案来源',
                    prop: 'source',
                    type: 'checkbox',
                    dataType: "number",
                    dicUrl: "/api/blade-system/dict-biz/dictionary",
                    dicQuery: {
                        code: 'individual_case'
                    },
                    props: {
                        label: "dictValue",
                        value: "dictKey"
                    },
                    rules: [{
                        required: true,
                        message: "请选择来源",
                        trigger: "click"
                    }],
                    span: 24
                }, {
                    labelWidth: 0,
                    prop: 'sourceRemark',
                    type: "textarea",
                    row: true,
                    span: 24
                }, {
                    labelPosition: "top",
                    label: '5.3督导备注',
                    prop: 'supervisionRemark',
                    type: "textarea",
                    row: true,
                    span: 24
                }, {
                    label: '督导签字：',
                    prop: 'supervisionSignature',
                    rules: [{
                        required: true,
                        message: "请填写督导",
                        trigger: "blur"
                    }]
                }, {
                    label: "批阅日期：",
                    prop: "supervisionDay",
                    type: "date",
                    format: "yyyy-MM-dd",
                    valueFormat: "yyyy-MM-dd",
                    hide: true,
                    rules: [{
                        required: true,
                        message: "请选择批阅日期",
                        trigger: "blur"
                    }],
                }]
            },
        }
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                this.orderForm = this.data
            }
        }
    },
    mounted() {
        this.orderForm = this.data
    },
    methods: {
        goNextHandle(num) {
            this.$emit("next", num)
        },
        handleSubmit(form, done, loading) {
            update(this.orderForm).then((res) => {
                // 获取新增数据的相关字段
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                // 数据回调进行刷新
                this.$refs.form.resetForm();
                done();
                this.$emit("refresh", res.data.data.id || '')
            }, error => {
                done();
                window.console.log(error);
            });
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/desk.scss";

</style>
<style lang="scss" scoped="scoped">
.one-title {
    padding: 30px 0;
    font-size: 20px;
    text-align: center;
}

</style>
